webpackJsonp([5],{

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddExpense_vue__ = __webpack_require__(145);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d4bb9e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExpense_vue__ = __webpack_require__(277);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(54)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34d4bb9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddExpense_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d4bb9e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExpense_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(55);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      expenseCategory: null,
      expenseAmount: null,
      expenseBy: null,
      expenseOn: null,
      expenseGroup: null,
      expenseDetails: null,
      error: false,
      errorMsg: null,
      groups: [], // Shape: [{id,name}]
      groupMemberList: [], // Shape: [{id, name}]
      categoriesList: [] // Shape: [expenseCategoryString]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.populateGroups();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    expenseGroup: {
      handler: function handler(newexpenseGroup) {
        console.log('newexpenseGroup: ', newexpenseGroup);
        this.populateCategories();
        this.populateGroupMembers();
      }
    }
  },
  methods: {
    saveEntry: function saveEntry() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var form;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form = {
                  expenseCategory: _this2.expenseCategory,
                  expenseAmount: _this2.expenseAmount,
                  expenseBy: _this2.expenseBy,
                  expenseOn: _this2.expenseOn,
                  expenseGroup: _this2.expenseGroup,
                  expenseDetails: _this2.expenseDetails
                };

                _this2.validateExpense(form);
                __WEBPACK_IMPORTED_MODULE_2__api__["c" /* secure */].saveEntry(form).then(function (res) {
                  _this2.message = 'New post saved: ', res;
                  _this2.$router.push('/home');
                }).catch(function (err) {
                  console.log('Error saving new post: ', err);
                  _this2.error = true;
                  _this2.errorMsg = err.response.data;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    populateGroups: function populateGroups() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var groupsArr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["c" /* secure */].getGroups();

              case 2:
                groupsArr = _context3.sent;

                _this3.groups = groupsArr.data.data;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    populateCategories: function populateCategories() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var categoriesArr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["c" /* secure */].getCategories(_this4.expenseGroup);

              case 2:
                categoriesArr = _context4.sent;

                _this4.categoriesList = categoriesArr.data.data;

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    populateGroupMembers: function populateGroupMembers() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var groupMemebersArr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["c" /* secure */].getGroupMemebers(_this5.expenseGroup);

              case 2:
                groupMemebersArr = _context5.sent;

                _this5.groupMemberList = groupMemebersArr.data.data;

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    validateExpense: function validateExpense(form) {
      if (!form.expenseCategory) form.expenseCategory = 'Others';
      if (!form.expenseAmount) form.expenseAmount = 10;
      if (!form.expenseBy) form.expenseBy = this.$store.state.user.id;
      if (!form.expenseOn) form.expenseOn = new Date();
      if (!form.expenseGroup) form.expenseGroup = 'Personal';
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(276);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(133)("0e184b36", content, true, {});

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(132)(true);
// imports


// module
exports.push([module.i, ".error[data-v-34d4bb9e]{color:red}.md-card[data-v-34d4bb9e]{padding:0 10px}", "", {"version":3,"sources":["E:/pwa-client/src/components/AddExpense.vue"],"names":[],"mappings":"AACA,wBACE,SAAW,CACZ,AACD,0BACE,cAAkB,CACnB","file":"AddExpense.vue","sourcesContent":["\n.error[data-v-34d4bb9e] {\r\n  color: red;\n}\n.md-card[data-v-34d4bb9e] {\r\n  padding: 0px 10px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-layout-item md-size-50 md-small-size-100"},[_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveEntry($event)}}},[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-size-33"},[_c('md-field',[_c('md-icon',[_vm._v("group")]),_vm._v(" "),_c('label',[_vm._v("Group")]),_vm._v(" "),_c('md-select',{attrs:{"name":"group","id":"group"},model:{value:(_vm.expenseGroup),callback:function ($$v) {_vm.expenseGroup=$$v},expression:"expenseGroup"}},_vm._l((_vm.groups),function(group){return _c('md-option',{key:group.id,attrs:{"value":group.id}},[_vm._v(_vm._s(group.name))])}))],1)],1),_vm._v(" "),_c('div',{staticClass:"md-layout-item md-size-33"},[_c('md-field',[_c('md-icon',[_vm._v("perm_identity")]),_vm._v(" "),_c('label',[_vm._v("Paid By")]),_vm._v(" "),_c('md-select',{attrs:{"name":"paidBy","id":"paidBy"},model:{value:(_vm.expenseBy),callback:function ($$v) {_vm.expenseBy=$$v},expression:"expenseBy"}},_vm._l((_vm.groupMemberList),function(paidBy){return _c('md-option',{key:paidBy.id,attrs:{"value":paidBy.id}},[_vm._v(_vm._s(paidBy.name))])}))],1)],1),_vm._v(" "),_c('div',{staticClass:"md-layout-item md-size-33"},[_c('md-field',[_c('md-icon',[_vm._v("date_range")]),_vm._v(" "),_c('label',[_vm._v("Paid On")]),_vm._v(" "),_c('md-input',{attrs:{"type":"date","aria-placeholder":"","placeholder":""},model:{value:(_vm.expenseOn),callback:function ($$v) {_vm.expenseOn=$$v},expression:"expenseOn"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item"},[_c('md-field',[_c('label',[_vm._v("Details")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.expenseDetails),callback:function ($$v) {_vm.expenseDetails=$$v},expression:"expenseDetails"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-size-33"},[_c('md-field',[_c('label',[_vm._v("Amount")]),_vm._v(" "),_c('span',{staticClass:"md-prefix"},[_vm._v("₹")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number"},model:{value:(_vm.expenseAmount),callback:function ($$v) {_vm.expenseAmount=$$v},expression:"expenseAmount"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"md-layout-item md-size-33"},[_c('md-autocomplete',{attrs:{"md-options":_vm.categoriesList},model:{value:(_vm.expenseCategory),callback:function ($$v) {_vm.expenseCategory=$$v},expression:"expenseCategory"}},[_c('label',[_vm._v("Category")])])],1)])]),_vm._v(" "),_c('md-button',{staticClass:"md-fab md-primary md-fab-bottom-right ",on:{"click":_vm.saveEntry}},[_c('md-icon',[_vm._v("done")])],1),_vm._v(" "),_c('md-snackbar',{staticClass:"error",attrs:{"md-position":"center","md-active":_vm.error},on:{"update:mdActive":function($event){_vm.error=$event}}},[_vm._v(_vm._s(_vm.errorMsg))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.2d7f69acf04bf7a2e5d4.js